import { Action, createReducer, on } from '@ngrx/store';
import { ISignupRequest, ISignupResponse } from '../models/signup.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { loadSignupRequest, loadSignupSuccess, loadSignupFailure } from '../actions/signup.actions';

export const signupFeatureKey = 'signup';

export interface SignupState {
  isLoading: boolean;
  loadSignup: ISignupRequest;
  loadSignupSuccess: ISignupResponse;
  loadSignupFailure: IGenericError<ErrorResponse>;
}

export const initialState: SignupState = {
  isLoading: false,
  loadSignup: undefined,
  loadSignupSuccess: undefined,
  loadSignupFailure: undefined
};

export const reducer = createReducer(
  initialState,

  //#region REGISTER
  on(loadSignupRequest, (state, action) => ({
    ...state,
    loadSignup: action.request,
    isLoading: true
  })),
  on(loadSignupSuccess, (state, action) => ({
    ...state,
    loadSignupSuccess: action.response,
    isLoading: false
  })),
  on(loadSignupFailure, (state, action) => ({
    ...state,
    loadSignupFailure: action.error,
    isLoading: false
  }))

  //#endregion
);

//#region REGISTER
export const getIsSignupLoading = (state: SignupState) => state.isLoading;
export const getIsSignupRequest = (state: SignupState) => state.loadSignup;
export const getIsSignupSuccess = (state: SignupState) => state.loadSignupSuccess;
export const getIsSignupFailure = (state: SignupState) => state.loadSignupFailure;
